<template>
  <div class="panel">
    <el-row>
      <h1>基本特性</h1>
    </el-row>
    <el-row class="feature-board">
      <el-col :span="6">
        <div class="title"><i class="el-icon-edit">&nbsp;</i>自定义中间件</div>
        <div class="content line">开发者可以自定义中间件，传入的HTTP</div>
        <div class="content line">请求可以由一系列中间件和最终操作来</div>
        <div class="content line">处理；开发者可查看GitHub或Godoc，</div>
        <div class="content line">获取中间件的使用文档。</div>
      </el-col>
      <el-col :span="6">
        <div class="title"><i class="el-icon-bell">&nbsp;</i>Json校验</div>
        <div class="content line">Tigo可以解析并验证请求的JSON或者</div>
        <div class="content line">From是否合法，例如检查所需值的存在</div>
        <div class="content line">以及存在的值是否符合规则。</div>
      </el-col>
      <el-col :span="6">
        <div class="title"><i class="el-icon-share">&nbsp;</i>路由管理</div>
        <div class="content line">Tigo为您提供了2种路由方式，一种</div>
        <div class="content line">使用简单的map定义路由的挂载，另</div>
        <div class="content line">一种使用Router数组，后者可以让</div>
        <div class="content line">开发者嵌套添加多个中间件。</div>
      </el-col>
    </el-row>
    <el-row class="feature-board">
      <el-col :span="6">
        <div class="title"><i class="el-icon-document">&nbsp;</i>模板支持</div>
        <div class="content line">Tigo提供了简单的html模板渲染功能，</div>
        <div class="content line">可查看文档的BaseHandler.Render</div>
        <div class="content line">方法。</div>
      </el-col>
      <el-col :span="6">
        <div class="title"><i class="el-icon-menu">&nbsp;</i>API集成</div>
        <div class="content line">Tigo提供了大量的API，除了创建服务</div>
        <div class="content line">所需要使用的API以外，还有进行http</div>
        <div class="content line">请求所需要的API等等。</div>
      </el-col>
      <el-col :span="6">
        <div class="title"><i class="el-icon-edit-outline">&nbsp;</i>功能扩展</div>
        <div class="content line">开发者可以自由定义控制层代码，扩展</div>
        <div class="content line">开发者所需的功能，详情可查看GitHub</div>
        <div class="content line">上的文档。</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "DocumentationFeatures",
    methods: {
      showInfo() {
        this.$alert('你果然点了，并且成功的找到了这里！', '缘分啊！', {
          confirmButtonText: '确定',
          callback: action => {
            this.$message({
              type: 'info',
              message: `action: ${ action }`
            });
          }
        });
      }
    }
  }
</script>

<style scoped>
  .panel {
    width: 100%;
    height: 450px;
    background-color: #f0f0f1;
  }

  h1 {
    margin-top: 39px;
  }

  .title {
    font-size: 20px;
    font-family: "Avenir", serif;
    margin-bottom: 10px;
  }

  .content {
    font-family: "Avenir", serif;
    color: #797e8e;
  }

  .feature-board {
    padding-left: 20%;
    margin-bottom: 30px;
  }

  @media screen and (max-width: 1060px) {
    .panel {
      width: 100%;
      height: 600px;
      background-color: #f0f0f1;
    }
  }

  @media screen and (max-width: 720px) {
    .panel {
      width: 100%;
      height: 700px;
      background-color: #f0f0f1;
    }
  }

  @media screen and (max-width: 500px) {
    .line {display: none}
    .panel {
      width: 100%;
      height: 300px;
      background-color: #f0f0f1;
    }
  }

  .line {}
</style>



// WEBPACK FOOTER //
// src/components/ch/DocumentationFeatures.vue